import { Grid, Typography } from "@mui/material";
import styled from "@emotion/styled";

export const MainStyledTypography = styled(Typography)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 800,
  fontSize: "24px",
  color: theme.palette.mainPrimary.prior,
  textTransform: "initial",
  lineHeight: "30px",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 800,
  fontSize: "24px",
  color: theme.palette.mainSecondary.prior,
  textTransform: "initial",
  lineHeight: "30px",
}));

export const ItemGrid = styled(Grid)`
  position: relative;
  width: 100%;

  &::before {
    content: "";
    position: absolute;
    background: url("/Image/subheader.svg") no-repeat left center;
    background-size: contain;
    width: 77px;
    height: 94px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  &::after {
    content: "";
    position: absolute;
    background: url("/Image/sub-header-right-img.png") no-repeat right center;
    background-size: contain;
    width: 138px;
    height: 94px;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Dark Mode: lift the α mark slightly so it stays readable on dark surfaces. */
  body[data-theme="dark"] &::after {
    filter: brightness(1.28) saturate(1.08);
  }

  body[data-theme="dark"] &::before {
    filter: brightness(1.35) saturate(1.12);
  }

  /* Mobile: brand graphics as subtle background, not competing with title */
  &[data-compact="true"]::before {
    opacity: 0.2;
    width: 40px;
    height: 48px;
    left: 4px;
  }

  &[data-compact="true"]::after {
    opacity: 0.16;
    width: 64px;
    height: 48px;
    right: 4px;
  }

  body[data-theme="dark"] &[data-compact="true"]::before {
    opacity: 0.28;
  }

  body[data-theme="dark"] &[data-compact="true"]::after {
    opacity: 0.26;
  }

  /* Chat-only: Search omits data-muted and keeps full-opacity desktop marks. */
  &[data-muted="true"]::before {
    opacity: ${(props) => (props.theme?.palette?.mode === "dark" ? 0.28 : 0.28)};
  }

  &[data-muted="true"]::after {
    opacity: ${(props) => (props.theme?.palette?.mode === "dark" ? 0.32 : 0.22)};
  }

  &[data-muted="true"][data-compact="true"]::before {
    opacity: ${(props) => (props.theme?.palette?.mode === "dark" ? 0.2 : 0.14)};
  }

  &[data-muted="true"][data-compact="true"]::after {
    opacity: ${(props) => (props.theme?.palette?.mode === "dark" ? 0.22 : 0.12)};
  }
`;
